import React, { useState } from 'react';

export default function VendorCardGeneratorModal({ user, onClose }) {
    const [tagline, setTagline] = useState(user.description ? user.description.substring(0, 50) + (user.description.length > 50 ? '...' : '') : 'Premium Party Rentals');
    const [promoCode, setPromoCode] = useState('');
    const [cardStyle, setCardStyle] = useState('modern'); // modern, bold, classic
    const [instagram, setInstagram] = useState(''); // NEW: Instagram state
    const [facebook, setFacebook] = useState(''); // NEW: Facebook state

    const storefrontUrl = `${window.location.origin}/#vendorProfile/${user.uid}`;
    const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(storefrontUrl)}`;
    const themeColor = user.themeColor || '#ec4899'; // Default pink if none selected

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        
        let styleCss = '';
        if (cardStyle === 'modern') {
            styleCss = `
                .card { border-radius: 30px; box-shadow: 0 20px 50px rgba(0,0,0,0.1); background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%); border: 1px solid #e5e7eb; }
                .header { color: ${themeColor}; }
            `;
        } else if (cardStyle === 'bold') {
            styleCss = `
                .card { background-color: ${themeColor}; color: white; border-radius: 20px; }
                .header { color: white; }
                .tagline { color: rgba(255,255,255,0.9); }
                .qr-container { background: white; padding: 25px; border-radius: 20px; }
                .scan-text { color: white; }
                .promo-badge { background: white; color: ${themeColor}; box-shadow: 0 4px 15px rgba(0,0,0,0.2); }
            `;
        } else {
            styleCss = `
                .card { border: 6px solid ${themeColor}; border-radius: 0px; background: white; }
                .header { color: #111827; text-transform: uppercase; letter-spacing: 3px; }
                .qr-container { border: 2px solid #e5e7eb; padding: 20px; }
                .promo-badge { border-radius: 0; text-transform: uppercase; border: 2px dashed white; }
            `;
        }

        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Promo Card - ${user.vendorName || 'Vendor'}</title>
                    <style>
                        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap');
                        body { font-family: 'Inter', sans-serif; display: flex; justify-content: center; align-items: center; min-height: 100vh; margin: 0; background: #f3f4f6; -webkit-print-color-adjust: exact; color: #1f2937; }
                        .card { width: 500px; padding: 60px 40px; text-align: center; overflow: hidden; position: relative; }
                        ${styleCss}
                        .logo { width: 120px; height: 120px; border-radius: 50%; object-fit: cover; margin-bottom: 24px; border: 4px solid white; box-shadow: 0 8px 20px rgba(0,0,0,0.1); background: white; }
                        .header { font-size: 36px; font-weight: 800; margin: 0 0 12px 0; line-height: 1.1; }
                        .tagline { font-size: 18px; margin: 0 0 40px 0; opacity: 0.8; font-weight: 400; }
                        .qr-container { display: inline-block; padding: 15px; background: white; border-radius: 16px; box-shadow: 0 10px 25px rgba(0,0,0,0.08); margin-bottom: 30px; }
                        .qr-code { width: 220px; height: 220px; display: block; }
                        .scan-text { font-size: 22px; font-weight: 800; margin: 0 0 8px 0; letter-spacing: -0.5px;}
                        .sub-text { font-size: 15px; opacity: 0.7; margin: 0; font-weight: 600;}
                        .social-links { margin-top: 15px; font-size: 16px; font-weight: 600; display: flex; justify-content: center; gap: 20px; opacity: 0.9; }
                        .promo-badge { display: inline-block; background: #111827; color: white; padding: 12px 28px; border-radius: 50px; font-weight: 800; font-size: 18px; margin-top: 30px; letter-spacing: 1px;}
                        @media print {
                            body { background: white; align-items: flex-start; padding-top: 20px;}
                            .card { box-shadow: none; border: 2px dashed #ccc; width: 100%; max-width: 600px; margin: 0 auto; page-break-inside: avoid; }
                            .no-print { display: none; }
                        }
                    </style>
                </head>
                <body>
                    <div class="card">
                        ${user.profilePicUrl ? `<img src="${user.profilePicUrl}" class="logo" />` : ''}
                        <h1 class="header">${user.vendorName || user.email}</h1>
                        <p class="tagline">${tagline}</p>
                        
                        <div class="qr-container">
                            <img src="${qrUrl}" class="qr-code" />
                        </div>
                        
                        <p class="scan-text">Scan to view inventory & book!</p>
                        <p class="sub-text">host-it.com</p>
                        
                        ${(instagram || facebook) ? `
                        <div class="social-links">
                            ${instagram ? `<span style="display:flex; align-items:center; gap:6px;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg> @${instagram.replace('@', '')}</span>` : ''}
                            ${facebook ? `<span style="display:flex; align-items:center; gap:6px;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg> /${facebook.replace('/', '')}</span>` : ''}
                        </div>
                        ` : ''}
                        
                        ${promoCode ? `<div class="promo-badge">Use Code: ${promoCode}</div>` : ''}
                    </div>
                    <div class="no-print" style="position: fixed; bottom: 30px; text-align: center; width: 100%;">
                        <button onclick="window.print()" style="padding: 14px 32px; background: ${themeColor}; color: white; border: none; border-radius: 50px; font-size: 18px; font-weight: bold; cursor: pointer; box-shadow: 0 4px 15px rgba(0,0,0,0.2); transition: transform 0.2s;">Print / Save as PDF</button>
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[300] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden">
                <div className="p-5 border-b border-gray-100 flex justify-between items-center bg-gray-50 flex-shrink-0">
                    <div>
                        <h2 className="text-xl font-bold flex items-center gap-2 text-gray-900">
                            <span>🖨️</span> Promo Card Generator
                        </h2>
                        <p className="text-xs text-gray-500 mt-1">Print these to display on tables or hand out at events.</p>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-red-500 transition p-2 bg-white rounded-full shadow-sm border border-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                </div>
                
                <div className="flex flex-col md:flex-row flex-grow overflow-y-auto md:overflow-hidden">
                    {/* Controls Panel */}
                    <div className="w-full md:w-1/3 p-6 border-b md:border-b-0 md:border-r border-gray-100 md:overflow-y-auto bg-white flex flex-col justify-between flex-shrink-0">
                        <div className="space-y-5">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Tagline</label>
                                <input 
                                    type="text" 
                                    value={tagline} 
                                    onChange={(e) => setTagline(e.target.value)} 
                                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-purple-500 outline-none transition"
                                    placeholder="e.g. Elevating your events!"
                                    maxLength="60"
                                />
                            </div>
                            
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Highlight a Promo Code (Optional)</label>
                                <input 
                                    type="text" 
                                    value={promoCode} 
                                    onChange={(e) => setPromoCode(e.target.value.toUpperCase())} 
                                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-mono uppercase focus:ring-2 focus:ring-purple-500 outline-none transition"
                                    placeholder="e.g. SUMMER10"
                                    maxLength="15"
                                />
                            </div>

                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-1">Instagram</label>
                                    <input 
                                        type="text" 
                                        value={instagram} 
                                        onChange={(e) => setInstagram(e.target.value)} 
                                        className="w-full p-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-purple-500 outline-none transition"
                                        placeholder="@handle"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-1">Facebook</label>
                                    <input 
                                        type="text" 
                                        value={facebook} 
                                        onChange={(e) => setFacebook(e.target.value)} 
                                        className="w-full p-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-purple-500 outline-none transition"
                                        placeholder="/page"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2">Design Style</label>
                                <div className="grid grid-cols-1 gap-2">
                                    <label className={`cursor-pointer p-3 border-2 rounded-lg flex items-center gap-3 transition ${cardStyle === 'modern' ? 'border-purple-500 bg-purple-50/50' : 'border-gray-200 hover:border-gray-300'}`}>
                                        <input type="radio" name="style" checked={cardStyle === 'modern'} onChange={() => setCardStyle('modern')} className="text-purple-600 focus:ring-purple-500" />
                                        <span className="font-semibold text-sm text-gray-800">Clean & Modern</span>
                                    </label>
                                    <label className={`cursor-pointer p-3 border-2 rounded-lg flex items-center gap-3 transition ${cardStyle === 'bold' ? 'border-purple-500 bg-purple-50/50' : 'border-gray-200 hover:border-gray-300'}`}>
                                        <input type="radio" name="style" checked={cardStyle === 'bold'} onChange={() => setCardStyle('bold')} className="text-purple-600 focus:ring-purple-500" />
                                        <span className="font-semibold text-sm text-gray-800">Bold Theme</span>
                                    </label>
                                    <label className={`cursor-pointer p-3 border-2 rounded-lg flex items-center gap-3 transition ${cardStyle === 'classic' ? 'border-purple-500 bg-purple-50/50' : 'border-gray-200 hover:border-gray-300'}`}>
                                        <input type="radio" name="style" checked={cardStyle === 'classic'} onChange={() => setCardStyle('classic')} className="text-purple-600 focus:ring-purple-500" />
                                        <span className="font-semibold text-sm text-gray-800">Classic Border</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="pt-6 mt-6 border-t border-gray-100">
                            <button 
                                onClick={handlePrint} 
                                className="w-full py-4 bg-gray-900 text-white font-bold rounded-xl shadow-lg hover:bg-black hover:shadow-xl transform hover:-translate-y-0.5 transition flex items-center justify-center gap-2"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
                                Open Printable Version
                            </button>
                        </div>
                    </div>

                    {/* Live Mini Preview Panel */}
                    <div className="w-full md:w-2/3 p-4 py-8 md:p-8 bg-gray-200 flex items-start md:items-center justify-center md:overflow-y-auto min-h-[500px] md:min-h-0">
                        {/* Scaled down preview container */}
                        <div 
                            className="bg-white relative flex flex-col items-center justify-center p-6 md:p-8 transition-all duration-300 w-full max-w-[320px] sm:max-w-sm md:max-w-md shadow-2xl my-auto origin-top md:origin-center"
                            style={{
                                borderRadius: cardStyle === 'modern' ? '24px' : cardStyle === 'bold' ? '16px' : '0px',
                                background: cardStyle === 'bold' ? themeColor : cardStyle === 'modern' ? 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)' : 'white',
                                border: cardStyle === 'classic' ? `6px solid ${themeColor}` : cardStyle === 'modern' ? '1px solid #e5e7eb' : 'none',
                                color: cardStyle === 'bold' ? 'white' : '#1f2937'
                            }}
                        >
                            {user.profilePicUrl && (
                                <img src={user.profilePicUrl} alt="Logo" className="w-20 h-20 rounded-full object-cover mb-4 border-4 border-white shadow-md bg-white" />
                            )}
                            
                            <h3 className="text-2xl font-extrabold text-center mb-1" style={{ color: cardStyle === 'bold' ? 'white' : cardStyle === 'classic' ? '#111827' : themeColor, textTransform: cardStyle === 'classic' ? 'uppercase' : 'none', letterSpacing: cardStyle === 'classic' ? '2px' : 'normal' }}>
                                {user.vendorName || user.email}
                            </h3>
                            <p className="text-sm text-center mb-6 opacity-80">{tagline}</p>
                            
                            <div className="bg-white p-3 rounded-2xl shadow-sm mb-6" style={{ border: cardStyle === 'classic' ? '2px solid #e5e7eb' : 'none' }}>
                                <img src={qrUrl} alt="QR Code" className="w-32 h-32 md:w-40 md:h-40" />
                            </div>
                            
                            <p className="font-bold text-lg mb-1" style={{ color: cardStyle === 'bold' ? 'white' : '#1f2937' }}>Scan to view & book!</p>
                            <p className="text-xs font-semibold opacity-70 mb-4">host-it.com</p>

                            {(instagram || facebook) && (
                                <div className="flex gap-4 text-sm font-semibold mb-2 opacity-90">
                                    {instagram && <span className="flex items-center gap-1.5"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg> @{instagram.replace('@', '')}</span>}
                                    {facebook && <span className="flex items-center gap-1.5"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg> /{facebook.replace('/', '')}</span>}
                                </div>
                            )}

                            {promoCode && (
                                <div 
                                    className="px-6 py-2 rounded-full font-bold text-sm shadow-md mt-2 tracking-wide uppercase"
                                    style={{
                                        background: cardStyle === 'bold' ? 'white' : '#111827',
                                        color: cardStyle === 'bold' ? themeColor : 'white',
                                        border: cardStyle === 'classic' ? '2px dashed white' : 'none',
                                        borderRadius: cardStyle === 'classic' ? '0' : '50px'
                                    }}
                                >
                                    Use Code: {promoCode}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}